<template>
  <div class="layout-wrap">
    <XHeader />
    <nuxt />
    <client-only>
      <LoginPop v-if="$store.state.app.showLoginPop" />
    </client-only>
    <XFooter />
  </div>
</template>

<script>
import LoginPop from '../components/logic-common/LoginPop'
import XHeader from '~/components/layout/VipRightHeader'
import XFooter from '~/components/logic-common/Footer'
export default {
  components: {
    XHeader,
    XFooter,
    LoginPop
  },
  data() {
    return {
      userLevel: { exp: 0, level: 0 }
    }
  },
  provide() {
    return {
      userLevel: () => this.userLevel,
      getLevelGap: () => {
        const { level, exp } = this.userLevel
        const min = this.levelConf[`vip${level}`]
        const max = this.levelConf[`vip${level + 1}`]
        if (!min) return { gap: 0, count: 0 }
        if (!max) return { gap: 0, count: min.count }
        return { gap: max.exp - exp, count: min.count }
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    levelConf() {
      return this.$store.state.app.levelConf
    }
  },
  methods: {
    clientCreated() {
      this.$store.dispatch('app/getLevelConf')
      if (this.$store.getters.isLogin) {
        this.$store.dispatch('getUserInfo')
        this.$request('queryUserLevel').then((data = {}) => {
          this.userLevel = data
        })
      }
    }
  }
}
</script>

<style lang="scss" src="~/assets/scss/vip-rights.scss"></style>
